import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import _ from "lodash";

const getShowPageScope = () => ShowPageScopeCollector.get([
  'layoutChanges',
  'previews',
  'canvasHistory'
]);

export const pushNewHistoryOfPreview = _.debounce((instance_id) => {
  const {
    layoutChanges,
    previews,
    canvasHistory
  } = getShowPageScope();

  const preview = previews.find(preview => preview.id === instance_id);

  if (!preview) {
    return;
  }

  canvasHistory.push(_.cloneDeep({
    instance_id,
    previewChanges: _.cloneDeep(layoutChanges),
    objects: preview.canvas.getObjects()
  }));
}, 200);
